import { useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import LogoMark from './LogoMark';
import { contact } from '../data/portfolio';
import { scrollToId } from './scroll';

const LINKS = [
    { id: 'journey', label: 'Journey' },
    { id: 'stack', label: 'Stack' },
    { id: 'hobbies', label: 'Beyond' },
    { id: 'contact', label: 'Contact' },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const { scrollY } = useScroll();
    useMotionValueEvent(scrollY, 'change', (v) => setScrolled(v > 40));

    return (
        <motion.header
            data-testid="navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${scrolled ? 'glass' : 'bg-transparent border-b border-transparent'}`}
            initial={{ y: -70, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
        >
            <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-3.5">
                <button
                    data-testid="nav-logo-button"
                    onClick={() => scrollToId('top')}
                    className="flex items-center gap-3"
                >
                    <LogoMark size={30} />
                    <span className="font-mono text-[11px] tracking-[0.3em] text-snow">
                        UJJWAL&nbsp;PRAVEEN
                    </span>
                </button>

                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => scrollToId(l.id)}
                            className="font-mono text-[11px] uppercase tracking-[0.22em] text-mist transition-colors hover:text-neon"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <a
                    data-testid="nav-resume-link"
                    href={contact.resumePath}
                    download="Ujjwal_Praveen_Resume.pdf"
                    className="rounded-full border border-neon/40 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-neon transition-all hover:bg-neon/10 hover:border-neon"
                >
                    Résumé
                </a>
            </div>
        </motion.header>
    );
}
